
import '../App.css';
import {
    BrowserRouter,
    Routes, //replaces "Switch" used till v5
    Route,
    HashRouter
} from "react-router-dom";
import React, { useState, useEffect } from 'react';
//import Home from './Home';

import ReactModal from 'react-modal';
import { auth, db } from '../config';
//import { ToastContainer, toast } from 'react-toastify';
import { toast } from 'wc-toast'

import Devices from './Devices';
import Content from './Content';
import Calendars from './Calendars';
import Sign_in from './Sign_in';
import Sign_up from './Sign_up';
import Subscription from './Subscription';
import { SetDevice, SetTrial, SetUnlicensed } from './redux/actions';
import { connect } from 'react-redux';
import moment from 'moment';
import Forget from './Forget';
import Settings from './Settings';
import AIGenerator from './AIGenerator';
import AISetting from './AISetting';
import AICreate from './AICreate';
import Success from './Success';
import Free_trials from './Free_trials';
import Welcome_screen from './Welcome_screen';
//import 'react-toastify/dist/ReactToastify.css';

const userdb = db.ref('userdb');

function App({ items, SetTrial, SetUnlicensed, SetDevice }) {

    const [pass, setPass] = useState('');
    const [touched1, setTouched1] = useState(false);
  
    const key = items.myid != null ? items.myid.id : null

    console.log('Key ',items.myid)

    function trial_ends(arr) {
        let now = new Date()
        let device_temp = 0;
        for (let i = 0; i < arr.length; i++) {
            let diff = moment(now).diff(new Date(Number(arr[i].time)), 'minutes')
          //  console.log('Trial days ',diff,' ',arr[i].time)
            diff = Math.abs(diff)
            if (diff < 7*1440 && arr[i].pay!=true && arr[i].free!=true)  device_temp++;
        }
        return device_temp;
    }

    function unlicensed(arr) {
        let now = new Date()
        let device_temp = 0;
        for (let i = 0; i < arr.length; i++) {
            let diff = moment(now).diff(new Date(Number(arr[i].time)), 'minutes')
            diff = Math.abs(diff)
            if (diff >= 7*1440) {
                if (arr[i].pay != true && arr[i].free != true) {
                    device_temp++;
                }
            }
        }
        return device_temp;
    }

    useEffect(() => {
        const subscribe = userdb.child(String(key)).child('devices').on('value', async (snapshot) => {
            if (snapshot != null && snapshot.val() != null) {
                let arr = Object.values(snapshot.val());
                let temp = [];
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].name != undefined) {
                        let obj = arr[i]
                        let new_obj = await db.ref('devices').child(String(arr[i].device)).once('value')
                     //   console.log('Got ',new_obj.val())
                        if (new_obj != null && new_obj.val() != null) {
                            obj.time = new_obj.val().time
                            temp.push(obj)
                        }
                    }
                }
                SetDevice(temp.length)
                let trials = trial_ends(temp)
                let unlicensed_devices = unlicensed(temp)

                console.log('Trials ',trials)
                console.log('Unlicensed ',unlicensed_devices)

                SetTrial(trials)
                SetUnlicensed(unlicensed_devices)
            }
            else {
                SetDevice(0)
                SetTrial(0)
                SetUnlicensed(0)
            }
        })

        return () => subscribe()
    }, [key])


    function toggleTouched1() {
        setTouched1(!touched1);
    }

    function handleMouseUp1() {
        // Handle smooth animation when clicking without holding
        setTimeout(() => {
            setTouched1(!touched1);
        }, 150);
    }

    const __doSingIn = async () => {
        try {
            let response = await auth.signInWithEmailAndPassword("n.joy@boomsoftware.co.uk", "2103199j");
        } catch (e) {
            console.error(e.message);
        }
    };

    function checking() {
        if (pass == "123") { __doSingIn() }
        else { toast("Wrong password !") }
    }

    useEffect(() => {
        __doSingIn()
    }, [])

    return (
        <div className="App">
            <HashRouter>
                <Routes>

                    <Route path="/" element={<Sign_in />} />
                    <Route path="/Forget" element={<Forget />} />

                    <Route path="/Content" element={<Content />} />
                    <Route path="/Calendars" element={<Calendars />} />
                    <Route path="/Devices" element={<Devices />} />

                    <Route path="/Sign_up" element={<Sign_up />} />
                    <Route path="/Subscription" element={<Subscription />} />
                    <Route path="/Settings" element={<Settings />} />
                
                    <Route path="/AIGenerator" element={<AIGenerator />} />
                    <Route path="/AISetting" element={<AISetting />} />
                    <Route path="/AICreate" element={<AICreate />} />

                    <Route path="/Free_trials" element={<Free_trials />} />

                    <Route path="/Welcome" element={<Welcome_screen />} />
            

                </Routes>
            </HashRouter>
            <wc-toast></wc-toast>
        </div>
    );
}

const mapStateToProps = state => {
    //  console.log(state)
    return {
        items: state._todoProduct
    }
}

export default connect(mapStateToProps, { SetTrial, SetUnlicensed,SetDevice })(App)